import {
  ActionBarContext,
  ModalService,
  addActionBarItem,
  registerFormInputComponent,
} from '@vendure/admin-ui/core';
import { firstValueFrom, map } from 'rxjs';

import { EurCurrencyFormInputComponent } from './eur-currency-form-input.component';
import { PricingRuleDataService } from './pricing-rule-data.service';
import { PricingRuleImportDialogComponent } from './pricing-rule-import-dialog.component';

/**
 * Shows the pricing-rule buttons only where the tenant registers the actions
 * pricing rules are made of. Only white label tenants do. Flowtech tenants take
 * their prices from KEA, and the server refuses the import and export there.
 */
const pricingRulesButtonState = (context: ActionBarContext) =>
  context.dataService.promotion.getPromotionActionsAndConditions().single$.pipe(
    map(({ promotionActions }) => {
      const visible = promotionActions.some(
        ({ code }) => code === 'cost_plus_percentage',
      );
      return { disabled: !visible, visible };
    }),
  );

export default [
  registerFormInputComponent(
    EurCurrencyFormInputComponent.id,
    EurCurrencyFormInputComponent,
  ),
  addActionBarItem({
    id: 'import-pricing-rules',
    label: 'Import',
    locationId: 'promotion-list',
    buttonStyle: 'outline',
    icon: 'upload',
    buttonState: pricingRulesButtonState,
    onClick: async (event, context: ActionBarContext) => {
      const modalService = context.injector.get(ModalService);

      await firstValueFrom(
        modalService.fromComponent(PricingRuleImportDialogComponent),
      );
    },
  }),
  addActionBarItem({
    id: 'export-pricing-rules',
    label: 'Export',
    locationId: 'promotion-list',
    buttonStyle: 'outline',

    icon: 'download',
    buttonState: pricingRulesButtonState,
    onClick: (event, context: ActionBarContext) => {
      const pricingRuleDataService = context.injector.get(
        PricingRuleDataService,
      );
      pricingRuleDataService.exportPricingRulesToCsv();
    },
  }),
];
